module.exports = __webpack_public_path__ + "static/media/PR8.48c8e076.jpg";